export const propertyUnits = [
    {
        id: 1,
        label: "1817 Treat Drive - 1817 Treat Drive Midwest City, OK 73110",
        value: "1817 Treat Drive - 1817 Treat Drive Midwest City, OK 73110",
        bedRooms: "4",
        bathRooms: "2.0",
        marketRent: "1200.00",
        securityDeposite: "1200.00",
        status: "Vacant"
    },
    {
        id: 2,
        label: "GF3, Block 58, Seaview Apartments, DHA Phase 5 - Test 3 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi, 75500 - Test 3",
        value: "GF3, Block 58, Seaview Apartments, DHA Phase 5 - Test 3 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi, 75500 - Test 3",
        bedRooms: "2",
        bathRooms: "2.0",
        marketRent: "1000.00",
        securityDeposite: "--",
        status: "Vacant"
    },
];
export const ownerEmails = [
    {
        id: 1,
        owner: "Sitafa and Jevon Gill",
        lastAnnouncementEmailSent: "02/09/2023"
    },
    {
        id: 2,
        owner: "Casa Rentals LLC",
        lastAnnouncementEmailSent: "--"
    },
    {
        id: 3,
        owner: "Aspire Premier Properties",
        lastAnnouncementEmailSent: "--"
    },
];
export const allAgreements = [
  {
    signers: "Loaurdes Mejia",
    agreementGenerationDate: "01/27/2023",
    status: "Out for Signing",
  },
];

export const outForSigningAgreements = [
    
  ];

  export const readyToCountersignAgreements = [
    
  ];

  export const printedAgreements = [
    
  ];

export const companyNames = [
    {
        value: "appfolio"
    },
    {
        value: "aab"
    },
    {
        value: "say eagle"
    },
    {
        value: "dymax tech"
    },
    {
        value: "other"
    },
];
export const names = [
    "seerat Ali",
    "Kainat Ali",
    "Akash",
    "Kashif",
    "Rimsha"
];